module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedSuperHeavyItalic.dfc8cce.woff2";